import { Component, computed, inject, input } from '@angular/core';
import { Button, Skeleton } from 'excellence-ui';
import { NgIcon } from '@ng-icons/core';
import { EnergyInterfacesStore } from '../../../energy-interfaces/stores/energy-interfaces.store';
import { ErrorComponent } from '../../../../shared/components/error-component/error-component';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { DashboardListCardSkeleton } from '../dashboard-list-card-skeleton/dashboard-list-card-skeleton';

@Component({
  selector: 'app-dashboard-energy-interfaces-card',
  imports: [
    Button,
    NgIcon,
    ErrorComponent,
    RouterLink,
    Skeleton,
    TranslocoPipe,
    DashboardListCardSkeleton,
  ],
  templateUrl: './dashboard-energy-interfaces-card.html',
})
export class DashboardEnergyInterfacesCard {
  private energyInterfacesStore = inject(EnergyInterfacesStore);

  organizationId = input.required<string>();

  private totalEnergyInterfaces = computed(
    () => this.energyInterfacesStore.energyInterfaces() ?? [],
  );
  protected energyInterfaces = computed(() =>
    this.totalEnergyInterfaces()
      .filter((l) => !l.isDeleted)
      .slice(0, 3),
  );
  protected totalEnergyInterfacesCount = computed(() => this.totalEnergyInterfaces().length);

  protected isLoading = this.energyInterfacesStore.isLoading;
  protected error = this.energyInterfacesStore.error;

  protected onClickReload() {
    this.energyInterfacesStore.load();
  }
}
